import { configureStore } from '@reduxjs/toolkit';
import servicePredictorReducer from './slices/servicePredictorSlice';
import authReducer from './slices/authSlice';

export const store = configureStore({
  reducer: {
    servicePredictor: servicePredictorReducer,
    auth: authReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
